/**
 * SSR 프리페치용 경로 정규화.
 *
 * 영구지침: docs/develop/seo/ssr-spec.md §15.1
 *
 * entry-server 의 프리페치 매처는 `$` 로 끝나는 정규식이라, 원본 URL(`req.originalUrl`)에
 * 쿼리스트링(`?utm_source=…`)이나 끝 슬래시가 붙으면 매칭이 빗나가 데이터 없는 셸
 * (홈 기본 title·canonical 없음·H1 없음)이 200 으로 나갔다(2026-09-15 라이브 실측).
 *
 * - 쿼리스트링·해시 제거 (둘 중 먼저 나오는 위치부터)
 * - 끝 슬래시 1개 제거 (루트 `/` 는 유지, 빈 문자열은 `/`)
 * - 퍼센트 인코딩은 그대로 둔다 — 세그먼트 디코딩은 각 매처가 한다
 *
 * 순수 함수(별칭 import 없음) — `npm test`(tsx --test)로 단독 실행된다.
 */
export function normalizeSsrPath(url: string): string {
  const cut = url.search(/[?#]/)
  let pathname = cut >= 0 ? url.slice(0, cut) : url
  if (pathname === '') return '/'
  if (pathname.length > 1 && pathname.endsWith('/')) {
    pathname = pathname.slice(0, -1)
  }
  return pathname
}
